export const REGEX =
  /((https?:\/\/)?(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

export const CALENDAR_META: Record<
  string,
  {
    favicon: string;
    domain: string;
  }
> = {
  calendly: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/calendly-icon.svg",
    domain: "calendly.com",
  },
  hubspot: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/hubspot-icon.svg",
    domain: "hubspot.com",
  },
  mixmax: {
    favicon: "https://www.storydoc.com/assets/images/companies/mixmax-icon.svg",
    domain: "mixmax.com",
  },
  chillipiper: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/chillipiper-icon.svg",
    domain: "chillipiper.com",
  },
  "sales-loft": {
    favicon:
      "https://www.storydoc.com/assets/images/companies/salesloft-icon.jpeg",
    domain: "salesloft.com",
  },
  "outreach-io": {
    favicon:
      "https://www.storydoc.com/assets/images/companies/outreach-icon.svg",
    domain: "outreach.com",
  },
  front: {
    favicon: "https://www.storydoc.com/assets/images/companies/front-icon.svg",
    domain: "front.com",
  },
  custom: {
    favicon: "https://www.storydoc.com/assets/images/companies/code.svg",
    domain: "Code",
  },
  yesware: {
    favicon:
      "https://www.storydoc.com/assets/images/companies/yesware-icon.png",
    domain: "yesware.com",
  },
};
